// extracted by mini-css-extract-plugin
module.exports = {"heatmapsContainer":"FalsePositiveDiagnosticsPage_heatmapsContainer__3H8gP","heatmapBlock":"FalsePositiveDiagnosticsPage_heatmapBlock__dqBMv"};